import { useState, useEffect, useRef } from "react";
import "./App.css";
import { Slide, ToastContainer } from "react-toastify";
import { FaRegArrowAltCircleUp } from "react-icons/fa";
import About from "./Components/About";
import BlogPage from "./Components/BlogPage";
import Dashboard from "./Components/Dashboard";
import FeedbackPage from "./Components/FeedbackPage";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import TeamsPage from "./Components/TeamsPage";
import ProductsPage from "./Components/ProductsPage";
import Technology from "./Components/Technology";
import CareersPage from "./Components/CareersPage";
import Features from "./Components/Features";

function App() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [careers, setCareers] = useState(false);
  const appRef = useRef(null);
  const handleScroll = () => {
    if (window.scrollY > 0) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };
  const handlElementScroll = (id) => {
    if (id === "careers") {
      setCareers(true);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      if (careers) {
        setCareers(false);
        return;
      }
      const element = document.getElementById(id);
      element?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="App">
      <div id="___gatsby" ref={appRef}>
        <div
          tabIndex="-1"
          id="gatsby-focus-wrapper"
          style={{ outline: "none" }}
        >
          <main>
            <Header handleScroll={handlElementScroll} />
            {careers ? (
              <CareersPage />
            ) : (
              <>
                <Dashboard />
                <Features />
                <Technology />
                <TeamsPage />
                <About />
                <ProductsPage />
                {/* <div className="funfacts-area ptb-50">
                  <div className="container">
                    <div className="section-title">
                      <h2>We always try to understand users expectation</h2>
                      <div className="bar"></div>
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna aliqua.
                      </p>
                    </div>
                    <div className="row">
                      <div className="col-lg-3 col-md-3 col-6">
                        <div className="funfact">
                          <h3>180K</h3>
                          <p>Downloaded</p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-6">
                        <div className="funfact">
                          <h3>20K</h3>
                          <p>Feedback</p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-6">
                        <div className="funfact">
                          <h3>500+</h3>
                          <p>Workers</p>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-6">
                        <div className="funfact">
                          <h3>70+</h3>
                          <p>Contributors</p>
                        </div>
                      </div>
                    </div>
                    <div className="contact-cta-box">
                      <h3>Have Any Questions About Us?</h3>
                      <p>Don't hesitate to contact us</p>
                      <a className="btn btn-primary" href="/contact/">
                        Contact Us
                      </a>
                    </div>
                    <div className="map-bg">
                      <img
                        src="https://spet-gatsby.envytheme.com/static/map-3f6e1ddb342185a26c476daa59c3a805.png"
                        alt="map"
                      />
                    </div>
                  </div>
                </div> */}
                <FeedbackPage />
                <BlogPage />
                {/* <TrialPage /> */}
              </>
            )}
            <ToastContainer
              transition={Slide}
              newestOnTop
            />
            <Footer />
          </main>
          {isScrolled && (
            <div
              className="go-top"
              aria-hidden="true"
              style={{ display: "block" }}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <FaRegArrowAltCircleUp />{" "}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
